/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostJourneysGetJourneyResponseDataTravelersInnerName } from './postJourneysGetJourneyResponseDataTravelersInnerName';
import { PostJourneysGetJourneyResponseDataTravelersInnerFrequentFlyerCardsInner } from './postJourneysGetJourneyResponseDataTravelersInnerFrequentFlyerCardsInner';
import { PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetails } from './postJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetails';
import { PostJourneysGetJourneyResponseDataTravelersInnerFirstFlightAcceptanceEligibility } from './postJourneysGetJourneyResponseDataTravelersInnerFirstFlightAcceptanceEligibility';

export interface PostJourneysGetJourneyResponseDataTravelersInner {
  /**
   * 搭乗者種別<br> ADT：以下の搭乗者種別のいずれにも合致しない<br> B15：DxAPIから返却された搭乗者種別がB15<br> CHD：以下のいずれかに合致<br>   1. 搭乗者種別がCHD<br>   1. 搭乗者種別が\"\"U\"\" + 05~11の2桁の数字<br>   1. SSR CHLDまたはUMNRがリレートしている<br>  INF：DxAPIから返却された搭乗者種別がINF<br> INS：以下のいずれかに合致<br>   1. DxAPIから返却された搭乗者種別がINS<br>   1. SSR INFTあり、かつINFINI作成PNR（予約を作成したオフィスコードが、設定ファイルに定義したINFINIオフィスコードのリストに含まれる）、かつフリーテキストに“OCCUPYING”が含まれる
   */
  passengerTypeCode: PostJourneysGetJourneyResponseDataTravelersInner.PassengerTypeCodeEnum;
  /**
   * 搭乗者ID
   */
  id: string;
  name?: PostJourneysGetJourneyResponseDataTravelersInnerName;
  /**
   * SSR DOCSの生年月日、SSR DOCSの生年月日が存在しない場合はNAMEエレメントの生年月日。マスキング要否がtrueの場合は\\*\\*\\*\\*-\\*\\*-\\*\\*にマスキングして返却する
   */
  dateOfBirth?: string;
  /**
   * 暗号化されたSSR DOCSの生年月日、SSR DOCSの生年月日が存在しない場合は暗号化されたNAMEエレメントの生年月日（yyyy-MM-dd形式）。マスキング要否がtrueの場合のみ返却する
   */
  encryptedDateOfBirth?: string;
  /**
   * 18歳未満であるか（18歳未満の場合にtrue。生年月日が未登録の場合はfalse）<br> 生年月日が登録済みの場合に生年月日をもとに導出する。
   */
  isUnder18?: boolean;
  /**
   * 単独小児旅客であるか<br> SSR UMNRが登録されている場合にtrue
   */
  isUnaccompaniedMinor: boolean;
  /**
   * 旅程全体におけるチェックイン状況<br> 搭乗者ごとに、紐づくすべてのjourneyElementのチェックインステータスをもとに判定する。<br> accepted:全便チェックイン済み<br> standBy:全便スタンバイチェックイン<br> partial:ineligible以外でチェックイン済み/スタンバイチェックイン/未チェックインの混在<br> notAccepted:ineligible以外で全便未チェックイン<br> ineligible:journeyの1便目が未チェックインで1便目のチェックイン可否判定の結果チェックイン不可
   */
  acceptanceStatusSummary: PostJourneysGetJourneyResponseDataTravelersInner.AcceptanceStatusSummaryEnum;
  /**
   * 1便目にSelectee制限あり（1便目にSelectee制限がある場合にtrue）
   */
  isSelecteeOnFirstFlight: boolean;
  /**
   * 同伴搭乗者ID
   */
  accompanyingTravelerId?: string;
  regulatoryDetails?: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetails;
  /**
   * 社員種別<br> bookable: DUTY STAFF<br> standby: SUBLO旅客
   */
  staffCategory?: PostJourneysGetJourneyResponseDataTravelersInner.StaffCategoryEnum;
  firstFlightAcceptanceEligibility: PostJourneysGetJourneyResponseDataTravelersInnerFirstFlightAcceptanceEligibility;
  /**
   * FFP情報のリスト<br>DxAPIから取得するCPR情報のうち、FFP情報を重複排除して返却
   */
  frequentFlyerCards?: Array<PostJourneysGetJourneyResponseDataTravelersInnerFrequentFlyerCardsInner>;
}
export namespace PostJourneysGetJourneyResponseDataTravelersInner {
  export type PassengerTypeCodeEnum = 'ADT' | 'B15' | 'CHD' | 'INF' | 'INS';
  export const PassengerTypeCodeEnum = {
    Adt: 'ADT' as PassengerTypeCodeEnum,
    B15: 'B15' as PassengerTypeCodeEnum,
    Chd: 'CHD' as PassengerTypeCodeEnum,
    Inf: 'INF' as PassengerTypeCodeEnum,
    Ins: 'INS' as PassengerTypeCodeEnum,
  };
  export type AcceptanceStatusSummaryEnum = 'accepted' | 'standBy' | 'partial' | 'notAccepted' | 'ineligible';
  export const AcceptanceStatusSummaryEnum = {
    Accepted: 'accepted' as AcceptanceStatusSummaryEnum,
    StandBy: 'standBy' as AcceptanceStatusSummaryEnum,
    Partial: 'partial' as AcceptanceStatusSummaryEnum,
    NotAccepted: 'notAccepted' as AcceptanceStatusSummaryEnum,
    Ineligible: 'ineligible' as AcceptanceStatusSummaryEnum,
  };
  export type StaffCategoryEnum = 'bookable' | 'standby';
  export const StaffCategoryEnum = {
    Bookable: 'bookable' as StaffCategoryEnum,
    Standby: 'standby' as StaffCategoryEnum,
  };
}
